import { ReactNode } from 'react';
import logProPurchaseGetStartedClicked from '@alltrails/analytics/events/logProPurchaseGetStartedClicked';
import useLanguageRegionCode from '@alltrails/shared/hooks/useLanguageRegionCode';
import Plan from 'types/Plan';
import Coupon from 'types/Coupon';
import * as styles from 'components/LandingPages/PrimaryLink/PrimaryLink.module.scss';
import Button, { ButtonProps } from '@alltrails/shared/denali/components/Button';
import { wrapUrlSafe } from 'utils/language_support_util';
import { getPurchaseScreenTypePlan } from 'utils/amplitudeHelper';

export default function PrimaryLink({
  buttonText,
  coupon,
  plan,
  to,
  desktopVariant,
  mobileVariant
}: {
  buttonText: ReactNode;
  plan: Plan;
  coupon: Coupon;
  to: string;
  desktopVariant: ButtonProps['variant'];
  mobileVariant: ButtonProps['variant'];
}) {
  const languageRegionCode = useLanguageRegionCode();

  return (
    <div className={styles.buttonContainer}>
      {/*
        Two buttons are needed in order to show different button variants based on screen width.
        Setting the variant prop to the 'useIsMobile' value results in flickering on page load.
      */}
      <Button
        className={styles.desktopButton}
        size="lg"
        width="fullOnMobile"
        text={buttonText}
        linkInfo={{
          href: wrapUrlSafe(to, languageRegionCode),
          useReactRouter: true
        }}
        onClick={() => {
          logProPurchaseGetStartedClicked({
            purchase_screen_type_plan: getPurchaseScreenTypePlan(plan, coupon)
          });
        }}
        testId="simple-pro-landing_page-primary"
        variant={desktopVariant}
      />
      <Button
        className={styles.mobileButton}
        size="lg"
        width="fullOnMobile"
        text={buttonText}
        linkInfo={{
          href: wrapUrlSafe(to, languageRegionCode),
          useReactRouter: true
        }}
        onClick={() => {
          logProPurchaseGetStartedClicked({
            purchase_screen_type_plan: getPurchaseScreenTypePlan(plan, coupon)
          });
        }}
        testId="simple-pro-landing_page-primary"
        variant={mobileVariant}
        allowWrap
      />
    </div>
  );
}
